import React, {
  Fragment,
  useEffect,
  useState
} from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from 'moment';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Input,
  Spinner,
  Table
} from "reactstrap";
import Skeleton from '../../components/vwSkeleton/vwSkeleton'
import VWModel from '../../components/vwModal/vwModal'
import AddProduct from "./AddProduct"
import {
  closeCreateProductModal,
  closeUpdateProductModal,
  getProductsList,
  openCreateProductModal,
  openUpdateProductModal,
  setProductDetails
} from "../../store/products/actions";
import EditProduct from "./EditProduct";
import { getPager } from "../../helper/common";
import VWPagination from "../../components/vwPagination/vwPagination";
import NoRecord from "../../components/NoRecords/noRecords";
import VWSpinner from "../../components/vwSpinner/vwSpinner";
import {
  CUSTOMER,
  MANUFACTURER,
  ORGANIZATION_ADMIN,
  RETAILER,
  SUPER_ADMIN
} from "../../store/users/role.constants";
import Message from "../../CommonData/Data/Message";
import VWLoading from "../../components/vwLoading/vwLoading";
import "../FixedColumn.css";

const style = {
  table: {
    width: '100%',
    display: 'table',
    borderSpacing: 0,
    borderCollapse: 'separate',
  },
  th: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
  },
};

const ProductList = (props) => {
  const { productList, isGetProductsPending, isCreateProductModalOpen, isUpdateProductModalOpen, currentProfile, errorMessage } = props;
  const [pageSize, setPageSize] = useState(10);
  const [pager, setPager] = useState({ currentPage: 1 });
  const [filter, setFilter] = useState();

  const isAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
    (currentProfile.roles[0].roleKey === SUPER_ADMIN || currentProfile.roles[0].roleKey === ORGANIZATION_ADMIN);
  const isManufacturer = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0].roleKey === MANUFACTURER

  ///-----------------------FILTER------------------------------------------------
  const buildQueryProductName = () => {
    const { productName } = filter || {};
    let searchProductName = '';
    if (productName) {
      searchProductName += `${productName}`;
    }
    return searchProductName
  }

  const buildQueryIsActive = () => {
    const { isActive } = filter || {};
    let searchIsActive = '';
    if ((isActive !== null) && (isActive !== undefined)) {
      searchIsActive += `${isActive}`;
    }
    return searchIsActive
  }

  const buildQueryCreatedBy = () => {
    const { createdBy } = filter || {};
    let searchCreatedBy = '';
    if (createdBy) {
      searchCreatedBy += `${createdBy}`;
    }
    return searchCreatedBy
  }
  const buildQueryCreatedDateTime = () => {
    const { createdDateTime } = filter || {};
    let searchCreatedDateTime = '';
    if (createdDateTime) {
      searchCreatedDateTime += `${createdDateTime}`;
    }
    return searchCreatedDateTime
  }
  const buildQueryUpdatedBy = () => {
    const { updatedBy } = filter || {};
    let searchUpdatedBy = '';
    if (updatedBy) {
      searchUpdatedBy += `${updatedBy}`;
    }
    return searchUpdatedBy
  }
  const buildQueryUpdatedDateTime = () => {
    const { updatedDateTime } = filter || {};
    let searchUpdatedDateTime = '';
    if (updatedDateTime) {
      searchUpdatedDateTime += `${updatedDateTime}`;
    }
    return searchUpdatedDateTime
  }

  const setPage = (page = 1) => {
    props.getProductsList(page, pageSize, buildQueryProductName(), buildQueryIsActive(), buildQueryCreatedBy(),
      buildQueryCreatedDateTime(), buildQueryUpdatedBy(), buildQueryUpdatedDateTime(), sortDirection, sortOrder);
    setPager(prevPager => {
      const totalPages = Math.ceil(props.totalRecords / pageSize);
      const visiblePages = 5;
      const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
      const newPages = [];
      for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
        newPages.push(i);
      }
      return {
        ...prevPager,
        currentPage: page,
        totalPages,
        pages: newPages,
      };
    });
  };

  useEffect(() => {
    const currentUpdatePager = getPager(props.totalRecords, 1, pageSize);
    setPager(currentUpdatePager);
  }, [props.totalRecords, pageSize]);

  // useEffect(() => {
  //   const currentPageNo = pager && pager.currentPage;
  //   setPage(currentPageNo);
  // }, []);

  useEffect(() => {
    setPage();
  }, [pageSize])

  const searchInputValidation = (event) => {
    const input = event.target;
    const { value } = input;

    setFilter({
      ...filter,
      [input.name]: value,
    });
  };

  const handleSearchClick = () => {
    setPage();
  };

  const handleKeypress = (e) => {
    if (e.key === 'Enter') {
      handleSearchClick();
    }
  };

  // useEffect(() => {
  //   if (filter) {
  //     handleSearchClick();
  //   }
  // }, [filter])

  //-----------------------SORTING------------------------------------------------

  const [sortDirection, setSortDirection] = useState('asc');
  const [sortOrder, setSortOrder] = useState(null);

  const handleSort = (column) => {
    if (sortOrder === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder(column);
      setSortDirection('asc');
    }
  };
  useEffect(() => {
    if (sortOrder && sortDirection) {
      setPage();
    }
  }, [sortOrder, sortDirection])

  // useEffect(() => {
  //   props.getProductsList();
  // }, [props.getProductsList])

  const handleClose = () => {
    props.closeCreateProductModal();
  };

  const handleOpenCreateProduct = () => {
    props.openCreateProductModal();
  };

  const handleUpdateClose = () => {
    const { closeUpdateProductModal } = props;
    closeUpdateProductModal();
  };

  const handleOpenUpdateProduct = (id) => {
    const { openUpdateProductModal, setProductDetails, productList } = props;
    const selected_product = productList.find((product) => {
      return product.id === id;
    });
    setProductDetails(selected_product);
    openUpdateProductModal();
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content">
          <Card>
            <CardTitle className="p-2 mb-0 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
              PRODUCTS
              {(isManufacturer) &&
                <Link
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleOpenCreateProduct}
                >
                  <em className="fas fa-plus me-2"></em> Create Product
                </Link>}
            </CardTitle>
          </Card>
          <Card className='p-4'>
            {errorMessage && (
              <Message
                type="danger"
                defaultMessage={errorMessage}
                baseClassName="alert"
              />
            )}
            <div style={{ maxHeight: "500px", overflowX: "auto" }}>
              <Table className="table table-hover table-nowrap w-100" size="sm" style={style.table}>
                <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: '10' }}>
                  <tr>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('productName')}>
                      NAME
                      {sortOrder === 'productName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('isActive')}>
                      STATUS
                      {sortOrder === 'isActive' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdBy')}>
                      CREATED BY
                      {sortOrder === 'createdBy' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('createdDateTime')}>
                      CREATED ON
                      {sortOrder === 'createdDateTime' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('updatedBy')}>
                      UPDATED BY
                      {sortOrder === 'updatedBy' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('updatedDateTime')}>
                      UPDATED ON
                      {sortOrder === 'updatedDateTime' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'} pe-2`} />
                      )}
                    </th>
                    {(isManufacturer) && <th className="text-center sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}>
                      ACTION
                    </th>}
                  </tr>
                  {/* <tr>
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          placeholder="Search"
                          name="productName"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={filter && filter.productName}
                        />
                      </FormGroup>
                    </th>
                    <th className="text-center">
                      <FormGroup>
                        <select
                          className="form-control"
                          name="isActive"
                          onChange={searchInputValidation}
                          value={filter && filter.isActive}
                        >
                          <option value="">Select</option>
                          <option value={true}>Active</option>
                          <option value={false}>Inactive</option>
                        </select>
                      </FormGroup>
                    </th>
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          placeholder="Search"
                          name="createdBy"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={filter && filter.createdBy}
                        />
                      </FormGroup>
                    </th>
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          placeholder="Search"
                          name="createdDateTime"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={filter && filter.createdDateTime}
                        />
                      </FormGroup>
                    </th>
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          placeholder="Search"
                          name="updatedBy"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={filter && filter.updatedBy}
                        />
                      </FormGroup>
                    </th>
                    <th>
                      <FormGroup>
                        <Input
                          className="form-control"
                          placeholder="Search"
                          name="updatedDateTime"
                          onChange={searchInputValidation}
                          onKeyPress={handleKeypress}
                          value={filter && filter.updatedDateTime}
                        />
                      </FormGroup>
                    </th>
                    <th></th>
                  </tr> */}
                </thead>
                <tbody>
                  {(productList && productList.length > 0) && !isGetProductsPending ?
                    productList.map((data, index) => (
                      <tr key={index}>
                        <td>{data.productName || "NA"}</td>
                        <td>
                          {data.isActive ? (
                            <Badge color="success">Active</Badge>
                          ) : (
                            <Badge color="danger">Inactive</Badge>
                          )}
                        </td>
                        <td>{data.createdBy || "NA"}</td>
                        <td>{data.createdDateTime ? moment(data.createdDateTime).format("DD MMM YYYY") : "NA"}</td>
                        <td>{data.updatedBy || "NA"}</td>
                        <td>{data.updatedDateTime ? moment(data.updatedDateTime).format("DD MMM YYYY") : "NA"}</td>
                        {(isManufacturer) && <td className="text-center sticky-column bg-white">
                          <Link
                            className="btn btn-sm btn-light"
                            onClick={() => handleOpenUpdateProduct(data.id)}
                          >
                            <em className="fa fa-edit"></em>
                          </Link>
                        </td>
                        }
                      </tr>
                    ))
                    : isGetProductsPending ?
                      <tr>
                        <td colSpan={9} align="center" className="p-4">
                          <Skeleton type="body" />
                          {/* <Spinner color="primary">Loading</Spinner> */}
                          {/* <VWSpinner /> */}
                          <VWLoading />
                        </td>
                      </tr>
                      :
                      <tr>
                        <td colSpan={9}>
                          <NoRecord />
                        </td>
                      </tr>
                  }
                </tbody>
              </Table>
            </div>
            <CardFooter>
              {productList && productList.length > 0 ?
                <VWPagination
                  pager={pager}
                  setPage={setPage}
                  totalRecords={props.totalRecords}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                /> : null
              }
            </CardFooter>
            <VWModel
              header="ADD PRODUCT"
              isOpen={isCreateProductModalOpen}
              handleClose={handleClose}
            >
              <AddProduct handleClose={handleClose} />
            </VWModel>
            <VWModel
              header="EDIT PRODUCT"
              isOpen={isUpdateProductModalOpen}
              handleClose={handleUpdateClose}
            >
              <EditProduct handleClose={handleUpdateClose} />
            </VWModel>
          </Card>


        </div >
      </React.Fragment >
    </>
  )
}

const mapStateToProps = (state) => ({
  isCreateProductModalOpen: state.products.isCreateProductModalOpen,
  isUpdateProductModalOpen: state.products.isUpdateProductModalOpen,
  productList: state.products.products,
  errorMessage: state.products.productListError,
  totalRecords: state.products.totalRecords,
  isGetProductsPending: state.products.isGetProductsPending,
  currentProfile: state.login.currentProfile,
});

const mapDispatchToProps = (dispatch) => ({
  getProductsList: (page, currentPage, searchProductName, searchIsActive, searchCreatedBy,
    searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder
  ) => dispatch(getProductsList(page, currentPage, searchProductName, searchIsActive, searchCreatedBy,
    searchCreatedDateTime, searchUpdatedBy, searchUpdatedDateTime, sortDirection, sortOrder)),
  openCreateProductModal: () => dispatch(openCreateProductModal()),
  closeCreateProductModal: () => dispatch(closeCreateProductModal()),
  openUpdateProductModal: () => dispatch(openUpdateProductModal()),
  closeUpdateProductModal: () => dispatch(closeUpdateProductModal()),
  setProductDetails: (data) => dispatch(setProductDetails(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ProductList);